<mat-toolbar class="app-toolbar" color="primary">
    <a mat-button routerLink="">
        <h1>Book Store</h1>
    </a>
    <div class="flex-spacer"></div>
    <div class="button-row">
        <a mat-button routerLink="">Books</a>
        <a mat-button routerLink="/book/add" *ngIf="isLogged">Add Book</a>
        <a mat-button routerLink="contact">Contacts</a>
        <a mat-button routerLink="admin">Admin</a>
        <button mat-icon-button aria-label="icon-button with a shopping_carticon">
            <mat-icon>shopping_cart</mat-icon>
        </button>
    </div>

</mat-toolbar>